// extracted by mini-css-extract-plugin
module.exports = {"langsNavBar":"langs_langsNavBar__FEBHY","lang":"langs_lang__24Tpr","activeLang":"langs_activeLang__2ZqZm"};